import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "../components/Reveal";
import { IMG } from "../data/content";

export default function Ramganga() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="ramganga-section" className="relative flex h-[80vh] items-center justify-center overflow-hidden">
      <motion.img
        src={IMG.river}
        alt="Elephants on the banks of the Ramganga near The Jamoon in Corbett"
        loading="lazy"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
        data-testid="ramganga-image"
      />
      <div className="absolute inset-0 bg-charcoal/55" />
      <div className="relative z-10 px-6 text-center">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-brass">Ramganga</p>
        </Reveal>
        <Reveal delay={0.12}>
          <h2 className="mx-auto mt-6 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight text-ivory sm:text-5xl lg:text-6xl">
            Where the forest <span className="italic text-brass">meets the river.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="mx-auto mt-7 max-w-xl text-sm font-light leading-relaxed text-ivory/80 sm:text-base">
            The Ramganga is the lifeline of Corbett. At The Jamoon it is also your neighbour —
            the sound you sleep to, the bank you walk at first light.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
